import { PropsWithChildren, ReactNode } from 'react';
import { Box, Flex } from 'reflexbox';
import styled, { css } from 'styled-components';
import { Breakpoint } from '@treams/treams-ui';

const Sidebar = styled(Box)<{ right?: boolean }>`
	${({ theme, right, width }) => css`
		${right
			? css`
					border-left: 1px solid ${theme.colors.lightBlue};
			  `
			: css`
					border-right: 1px solid ${theme.colors.lightBlue};
			  `}

		width: ${width ?? (right ? 340 : 270)}px;
	`}

	@media screen and (max-width: ${Breakpoint.Medium}) {
		width: 100%;
	}
`;

export function SidebarLayout(
	props: PropsWithChildren<{
		sidebar: ReactNode;
		sidebarWidth?: number;
		isSidebarOpen?: boolean;
		right?: boolean;
	}>,
) {
	const mobileSidebarDisplay =
		props.isSidebarOpen === undefined ? 'block' : props.isSidebarOpen ? 'block' : 'none';

	const tabletFlexDirection = props.right ? 'column-reverse' : 'column';
	const desktopFlexDirection = props.right ? 'row-reverse' : 'row';

	return (
		<Flex
			alignItems="stretch"
			flexDirection={[tabletFlexDirection, tabletFlexDirection, desktopFlexDirection]}
			flexGrow={1}
		>
			<Sidebar
				display={[mobileSidebarDisplay, mobileSidebarDisplay, 'block']}
				flexShrink={0}
				flexGrow={0}
				right={props.right}
				width={props.sidebarWidth}
				maxWidth={['none', 'none', '33%']}
			>
				{props.sidebar}
			</Sidebar>
			<Flex flexShrink={1} flexGrow={1} flexDirection="column">
				{props.children}
			</Flex>
		</Flex>
	);
}
